import { type ReactNode } from 'react';
import { cn } from './cn';

export interface EmptyStateProps {
  /** Icon element (typically a lucide icon). */
  icon?: ReactNode;
  title: string;
  description?: ReactNode;
  /** Optional action (typically a Button). */
  action?: ReactNode;
  className?: string;
}

/** Centered placeholder for empty collections / unbuilt features. */
export function EmptyState({
  icon,
  title,
  description,
  action,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center rounded-2xl border border-dashed border-surface-border bg-surface-1/50 px-6 py-16 text-center',
        className,
      )}
    >
      {icon && (
        <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-surface-3 text-accent">
          {icon}
        </div>
      )}
      <h3 className="text-base font-semibold text-zinc-100">{title}</h3>
      {description && (
        <p className="mt-1.5 max-w-md text-sm text-zinc-500">{description}</p>
      )}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
